// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"387":"cook","659":"customer","884":"admin"}[chunkId] || chunkId) + "." + {"186":"b92ab6f9","203":"f5b1af0b","387":"48a796a0","510":"a1079a25","659":"116a6f72","699":"35ca5943","880":"6294b95b","884":"0ac9e3bc"}[chunkId] + ".chunk.js";
};